__turbopack_context__.v({
  "active": "CUfTbq_active",
  "asButton": "CUfTbq_asButton",
  "gold": "CUfTbq_gold",
  "link": "CUfTbq_link",
  "row": "CUfTbq_row",
  "underline": "CUfTbq_underline",
});
